export default interface HighSchoolTeachingAidOption {
  readonly id?: number;
  readonly regular: boolean;
  readonly practical: boolean;
}

export const HighSchoolTeachingAidOptionInital: HighSchoolTeachingAidOption = {
  regular: false,
  practical: false
};
